module.exports = __webpack_public_path__ + "img/logo.812ac4b7.png";